import React from 'react'

import { GetCustomerCopyFunc, WORKLIFE_SERVICE_IDS } from '@lyrahealth-inc/shared-app-logic'

import { defaultCustomer } from './default'
import {
  WorkLifeIconDependentCare,
  WorkLifeIconFinancial,
  WorkLifeIconIdentity,
  WorkLifeIconLaw,
} from '../atoms/icons/WorkLifeIcons'

/* eslint-disable formatjs/no-literal-string-in-jsx */

export const getAppleWorkLifeServices = () => {
  return {
    FINANCIAL_SERVICES: {
      identifiers: WORKLIFE_SERVICE_IDS.FINANCIAL_SERVICES,
      title: 'Financial Well-Being',
      iconSvg: <WorkLifeIconFinancial size={48} />,
      paragraph: 'Your partner in financial success:',
      bullets: [
        'Financial planning for retirement, education, and goals',
        'Get help managing loans, bankruptcy, and estate planning',
        'Personal and family finances, such as child support and tax preparation.',
      ],
      CTA: 'Plan your finances',
      PATH: 'https://www.msamembers.net/',
    },
    LEGAL_SERVICES: {
      identifiers: WORKLIFE_SERVICE_IDS.LEGAL_SERVICES,
      title: 'Legal resources',
      iconSvg: <WorkLifeIconLaw size={48} />,
      paragraph: 'Comprehensive legal support:',
      bullets: [
        'Family law and other legal consultations',
        'Discounted attorney fees',
        'On-demand legal resources (forms, templates, and more)',
      ],
      CTA: 'Access legal resources',
      PATH: 'https://www.clclegalforms.com/clc/index.cfm?event=base:home',
    },
    IDENTITY_THEFT: {
      identifiers: WORKLIFE_SERVICE_IDS.IDENTITY_THEFT,
      title: 'Identity theft support',
      iconSvg: <WorkLifeIconIdentity size={48} />,
      paragraph: 'Protect yourself and your family with:',
      bullets: ['Comprehensive resources and support', 'Expert guidance', 'Support to navigate your options'],
      CTA: 'Access legal resources',
      PATH: 'https://www.clclegalforms.com/clc/index.cfm?event=base:home',
    },
    DEPENDENT_CARE: {
      identifiers: WORKLIFE_SERVICE_IDS.DEPENDENT_CARE,
      title: 'Work-life benefits',
      iconSvg: <WorkLifeIconDependentCare size={48} />,
      paragraph: 'Comprehensive support for your caregiving journey:',
      bullets: [
        'Child, elder, and adult caregiver resources',
        'Support for adoptions, parenting, pet care, and more family needs',
        'Educational resources and personal development',
      ],
      CTA: 'Call (844) 687-0850, ext. 1',
      PATH: 'tel:844-687-0850,1',
    },
  }
}

export const appleCustomer: GetCustomerCopyFunc = (props) => {
  const defaultCopy = defaultCustomer(props)
  const APPLE_WORKLIFE_SERVICES = getAppleWorkLifeServices()

  return {
    ...defaultCopy,
    workLifeServices: [
      APPLE_WORKLIFE_SERVICES.FINANCIAL_SERVICES,
      APPLE_WORKLIFE_SERVICES.LEGAL_SERVICES,
      APPLE_WORKLIFE_SERVICES.IDENTITY_THEFT,
      APPLE_WORKLIFE_SERVICES.DEPENDENT_CARE,
    ],
  }
}
